module.exports = ".numberCol {\n  text-align: right;\n  vertical-align: baseline;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/cost-viewer/cost-viewer.component.css
// module id = ./src/app/components/cost-viewer/cost-viewer.component.css
// module chunks = main